.chat-action-button {
    all: unset;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    font-size: 15px;
    cursor: pointer;
}
